<template>
  <div class="schedule-entry">
    <h3 class="entry-title" @click="toggleDetails()" :class="{expandable: this.hasDetails()}">
      <span>{{ entry.title }}</span>
      <font-awesome-icon class="arrow" icon="chevron-down" v-if="!hasDetailsExpanded && this.hasDetails()"/>
      <font-awesome-icon class="arrow" icon="chevron-up" v-if="hasDetailsExpanded"/>
    </h3>
    <div class="details" v-if="hasDetailsExpanded">
      <div v-if="!!this.entry.details" class="entry-details" v-html="this.entry.details"></div>

      <div class="entry-details" v-for="(participant, x) in this.entry.participants" :key="x">
        <strong>{{participant.name}}</strong>
        <br/>
        <div v-html="participant.details"></div>
      </div>
    </div>

    <p v-if="this.entry.description">
      <truncate class="description" collapsedTextClass="collapsed" clamp="read more" less="read less" :text="entry.description" :length="150" v-if="entry.description"></truncate>
    </p>
  </div>
</template>

<script>
import truncate from 'vue-truncate-collapsed'

export default {
  name: 'ScheduleEntry',
  props: ['entry'],
  components: {truncate},
  data() {
    return {
      hasDetailsExpanded: false
    }
  },
  computed: {
  },
  methods: {
    toggleDetails: function(){
      if (!this.hasDetails()) { return }
      this.hasDetailsExpanded = !this.hasDetailsExpanded
    },
    hasDetails: function() {
      return !!this.entry.details || !!this.entry.participants
    }
  }
}
</script>

<style lang="scss" scoped>
  .entry-title.expandable {
    .arrow {
      width: auto;
      margin-left: 2px;
      font-size: 22px;
    }
  }
  .entry-details {
    ::v-deep a {
      color: inherit;
      text-decoration: underline;
    }
  }
</style>
